import { useState } from "react";
import TabPanel from "@mui/lab/TabPanel";
import { Grid, Button } from "@mui/material";
import { DataGrid } from "@mui/x-data-grid";
import DecisionTree from "../../new_questions/DecisionTree";

/**
 * This component's name is not definitive, this is a test Decision Tree
 *
 * @param {*} param0
 */
export default function NewDecisionTree({
  ingredients,
  loading,
  columns,
  pageSize,
  currentPage,
  checkAccessLimit,
  openDrawer,
}) {
  const [results, setResults] = useState({});

  const transformedRows = (
    results.length > 0 ? results : ingredients?.ingredientsData || []
  ).map((row) => ({
    ...row,
    id: row._id || row.id,
  }));

  return (
    <TabPanel value="4">
      <Grid container spacing={2} columns={16} style={{ marginBottom: "30px" }}>
        <DecisionTree setResults={setResults} />
      </Grid>

      <DataGrid
        autoHeight
        getRowHeight={() => ""}
        rows={transformedRows}
        getRowId={(row) => row.id || row._id || row.code || JSON.stringify(row)}
        loading={loading}
        rowCount={
          results.length > 0 ? transformedRows?.length : ingredients?.total
        }
        columns={columns}
        pagination
        pageSize={pageSize}
        pageSizeOptions={[10, 15, 20, 25, 50, 75, 100]}
        paginationMode={results.length > 0 ? "client" : "server"}
        paginationModel={{ page: currentPage, pageSize: pageSize }}
        onPaginationModelChange={(model) => {
          checkAccessLimit(model.page, model.pageSize);
        }}
        initialState={{
          pagination: {
            paginationModel: {
              page: 0,
              pageSize: pageSize,
            },
          },
        }}
        onRowClick={(params) => {
          openDrawer(params.row);
        }}
      />
    </TabPanel>
  );
}
